import styled from 'styled-components';

const H2 = styled.h2`
  font-size: 1.5em;
  font-weight: 600;
`;

export default H2;



// WEBPACK FOOTER //
// ./app/components/H2/index.js